import { normalizeAppState } from "./domain";
import type { AppState } from "./types";

export type TrenBackup = {
  format: "tren-cut-backup";
  version: 1;
  exportedAt: string;
  appVersion: string;
  state: AppState;
};

export function createBackup(state: AppState, appVersion: string): TrenBackup {
  return {
    format: "tren-cut-backup",
    version: 1,
    exportedAt: new Date().toISOString(),
    appVersion,
    state: normalizeAppState(state)
  };
}

export function parseBackup(text: string): AppState {
  const parsed = JSON.parse(text) as Partial<TrenBackup>;
  if (parsed.format !== "tren-cut-backup" || parsed.version !== 1 || !parsed.state) {
    throw new Error("This is not a supported TREN CUT backup file.");
  }
  return normalizeAppState(parsed.state);
}

export function downloadBackup(state: AppState, appVersion: string): void {
  const backup = createBackup(state, appVersion);
  const blob = new Blob([JSON.stringify(backup, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `tren-cut-backup-${new Date().toISOString().slice(0, 10)}.json`;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

